import LocalHeader from '../../../../../components/Header/Header';

const Header = () => {
  return <LocalHeader />;
};

export default Header;
